/**
 * Словари фильтров для Блока 4 «Подбери крючки» — экран 2.4.2 (вариант hooks).
 * Источник: PRD `docs/prd/v4/06-block-4-handles.md`.
 *
 * Прототипного покрытия для крючков нет — рендеринг строится по тем же правилам, что у ручек:
 * вертикальный список chip-фильтров, AND между группами, OR внутри.
 */

/**
 * Цвета крючков. Изначально взяты из PRD §06 (10 значений), затем реконсилированы
 * с реальными данными каталога (класс B-220, сторож `vocab-drift.ts`): чип «Разные»
 * имел 0 крючков в данных (мёртвый чип) и убран — он показывался, но ничего не
 * находил. Остальные 9 значений подтверждены ненулевыми совпадениями. Дрейф
 * (мёртвый чип / недостижимые данные) ловит сторож в `scripts/import-handles.ts`.
 */
export const HOOK_COLORS = Object.freeze([
  'Хром',
  'Чёрный',
  'Сатин / Никель',
  'Алюминий / Серый',
  'Латунь',
  'Золото',
  'Цветные',
  'Медь / Бронза / Олово',
  'Белый',
] as const);

export type HookColor = (typeof HOOK_COLORS)[number];

/**
 * Подкатегории крючков по числу рожков + катч-олл «Прочие».
 *
 * Значения ОБЯЗАНЫ совпадать с `handles.shape` в БД символ-в-символ — это выход
 * канонизатора `canonHookShape` (`../import/handle-shape-canon`): `HOOK_SHAPE_CANON`
 * хранит канон БЕЗ суффикса «крючки» (ONE/TWO/THREE) + катч-олл `OTHER='Прочие'`.
 * Эти строки уходят в `shapes=` фильтра (HandlesCatalogView) → должны матчить D1.
 * Прежний комментарий «в БД хранятся ровно эти строки» (с «крючки») был устаревшим:
 * в D1 лежат канон-строки без «крючки» (кол-ва на 2026-06: Одно 128 / Двух 274 /
 * Трёх 123 / Прочие 36), а `…рожковые крючки` в `shapes=` не находили ничего.
 * Дрейф ловит регресс-тест в `hooks-vocabulary.test.ts` (сверка с HOOK_SHAPE_CANON).
 */
export const HOOK_SUBCATEGORIES = Object.freeze([
  'Однорожковые',
  'Двухрожковые',
  'Трёхрожковые',
  'Прочие',
] as const);

export type HookSubcategory = (typeof HOOK_SUBCATEGORIES)[number];
